function p (num) {
  return num.toString().padStart(2, '0')
}

export default {
  install($Vue) {
    // eslint-disable-next-line
    $Vue.prototype.$utils = {
      formatTimestamp (timestamp) {
        const date = new Date(timestamp)
        return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}
          ${p(date.getHours())}:${p(date.getMinutes())}:${p(date.getSeconds())}`
      }
    }
  }
}
